var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInfoHollow = function SvgInfoHollow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3B7CC9",
    fillRule: "evenodd",
    d: "M20 31.667c-6.443 0-11.667-5.224-11.667-11.667S13.557 8.333 20 8.333 31.667 13.557 31.667 20 26.443 31.667 20 31.667M5 20c0-8.284 6.716-15 15-15s15 6.716 15 15-6.716 15-15 15S5 28.284 5 20m16.667-6.667a1.667 1.667 0 1 0-3.334 0 1.667 1.667 0 0 0 3.334 0m-1.665 15h1.665a1.667 1.667 0 0 0 0-3.333v-6.667c0-.92-.747-1.666-1.667-1.666h-1.667a1.667 1.667 0 0 0 0 3.333v5a1.667 1.667 0 0 0 0 3.333h1.67",
    clipRule: "evenodd"
  })));
};
export default SvgInfoHollow;